import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

// API/Components
import { formatDateTime } from './enums';
import {  BuildDataGridCell, BuildDischargeEventCell, BuildGenericMeasurementCell } from './ui_helpers';
import NoItemsOverlay from '../components/no_items_overlay';

// Material UI
import { DataGrid } from '@mui/x-data-grid';


// System Trend Report table columns
const columns = [
	{
		field: 'start_datetime',
		headerName: 'Event Start Date',
		description: 'Event Start Date and Time',
		minWidth: 180,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => formatDateTime(params.value),
	},
	{
		field: 'event_type',
		headerName: 'Event Type',
		description: 'Event Type',
		minWidth: 150,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildDischargeEventCell(params.value),
	},
	{
		field: 'duration_text',
		headerName: 'Duration',
		description: 'Duration',
		minWidth: 120,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildDataGridCell(params.value)
	},
	{
		field: 'capacity',
		headerName: 'Capacity',
		description: 'Capacity Drained/Replenished',
		minWidth: 120,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildGenericMeasurementCell(params.value, 'Ah', 2, '-.-')
	},
	{
		field: 'energy',
		headerName: 'Energy',
		description: 'Average Energy',
		minWidth: 120,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildGenericMeasurementCell(params.value, 'kWh', 2, '----.--')
	},
	{
		field: 'power',
		headerName: 'Power',
		description: 'Average Power',
		minWidth: 120,
		flex: 1,
		headerAlign: "center",
		renderCell: (params) => BuildGenericMeasurementCell(params.value, 'kW', 2, '---.--')
	},
	{
		field: 'note',
		headerName: 'Note',
		description: 'Measurement Notes',
		minWidth: 190,
		flex: 5,
		headerAlign: "left",
	},
];


export default function DischargeEventsList(props) {
	const { locationID, eventsData, loading } = props;
	
	const [isLoading, setIsLoading] = useState(loading);
	const [pageSize, setPageSize] = useState(50);

	const navigate = useNavigate();

	useEffect(() => {
		setIsLoading(loading);
	}, [loading]);

	function convertDateTimeToLinkString(dateTime) {
		return dateTime.replace('-', '').replace('-', '').replace('T', '').replace(':', '').replace(':', '').replace('Z', '');
	}
	
	return (
		<DataGrid
			getRowId={(row) => convertDateTimeToLinkString(row.start_datetime)}
			rows={eventsData}
			columns={columns}
			loading={isLoading}
			density="compact"
			pagination
			pageSizeOptions={[25, 50, 100]}  // Max pagination size for DataGrid (Free Edition) is 100
			onRowClick={(rowParams) => {
				const dischargeDateTime = rowParams.id;
				navigate(`/location/${locationID}/discharges/${dischargeDateTime}/`);
			}}
			slots={{
				noRowsOverlay: NoItemsOverlay,
			}}
			slotProps={{
				noRowsOverlay: { noItemsText: 'No Discharge/Charge Events' },
			}}
			sx={{
				padding: 1,
				height: '100%'
			}}
		/>
	);
}